<template>
  <div>

    <data-table
    ref="permitsduetable"
    table-ref="permitsduetable"

    title="Permits"
    icon="fa fa-list"
    hide-org-badge
    :show-search="false"

    :url="'/permits/site/' + rowData.id"
    :fields="fields"

    />


  </div>

</template>

<script>
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import {settings} from '@/components/Data'

export default {

mixins: [DateMixins, NumberMixins],


props: {
  rowData: {
    type: Object,
    required: true
  }
},

  data () {
    return {
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'site_id'
        },
        {
          name: 'permitType',
          title: 'Type',
          sortField: 'permitType'
        },
        {
          name: 'applied',
          title: 'Applied',
          callback: this.formatDate,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'issued',
          title: 'Issued',
          callback: this.formatDate,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'amount',
          title: 'Amount',
          callback: this.formatNumber
        },
        {
          name: 'renewalPeriod',
          title: 'Period',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'ref1',
          title: settings.ref1Label,
          sortField: 'ref1',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'ref2',
          title: settings.ref2Label,
          sortField: 'ref2',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'expiry',
          title: 'Expiry',
          titleClass: 'text-danger',
          dataClass: 'text-danger',
          callback: this.formatDate
        },

    ]
  }
}
}

</script>



// WEBPACK FOOTER //
// Permits.vue?e8ce68e8